import { createSlice } from '@reduxjs/toolkit';
import { Status } from 'ui-widgets';
import { representativesList } from '../../types';

export const initialState = {
  // TODO: refactor without type assertion, or add comment
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  representativesList: {} as representativesList,
  status: Status.IDLE,
  productId: null,
};

const representativesSlice = createSlice({
  name: 'representatives',
  initialState,
  reducers: {
    setRepresentatives(state, { payload }) {
      state.representativesList = payload;
    },
    setStatus(state, { payload: { status, productId } }) {
      state.status = status;
      state.productId = productId;
    },
  },
});

export const { setRepresentatives, setStatus } = representativesSlice.actions;
export default representativesSlice.reducer;
